import { createContext, useContext, useState, useEffect, useCallback } from "react";

const LANGUAGES = [
  { code: "en", name: "English", flag: "🇬🇧" },
  { code: "es", name: "Español", flag: "🇪🇸" },
  { code: "pt", name: "Português", flag: "🇧🇷" },
  { code: "fr", name: "Français", flag: "🇫🇷" },
  { code: "de", name: "Deutsch", flag: "🇩🇪" },
  { code: "ca", name: "Català", flag: "🇦🇩" },
];

const TRANSLATIONS = {
  en: {
    title: "Agentic Teams Marketplace",
    subtitle: "Find the perfect team to boost your workspace",
    search_placeholder: "Search teams, categories, keywords...",
    categories: "Categories",
    all: "All",
    price: "Price",
    free: "Free",
    paid: "Paid",
    rating: "Rating",
    installs: "Installs",
    reviews: "Reviews",
    review_count: "{n} reviews",
    install_count: "{n} installs",
    install: "Install",
    installed: "Installed",
    details: "Details",
    description: "Description",
    version: "Version",
    tags: "Tags",
    author: "Author",
    updated: "Updated",
    latest_version: "Latest Version",
    screenshots: "Screenshots",
    no_results: "No teams found",
    loading: "Loading...",
    error: "Something went wrong",
    back: "Back to Marketplace",
    your_teams: "My Agentic Teams",
    backoffice: "Backoffice",
    publish_team: "Publish Team",
    edit_team: "Edit Team",
    team_name: "Team Name",
    team_slug: "URL slug",
    team_description: "Description",
    team_short_desc: "Short Description",
    team_category: "Category",
    team_tags: "Tags (comma separated)",
    team_price: "Price (€, 0 for free)",
    team_repo: "GitHub Repository URL",
    team_tag: "Version Tag",
    team_screenshots: "Screenshot URLs (one per line)",
    save: "Save",
    cancel: "Cancel",
    delete: "Delete",
    status_draft: "Draft",
    status_published: "Published",
    no_teams: "You haven't published any teams yet",
    select_space: "Select a workspace",
    create_space: "Create new workspace",
    space_name: "Workspace name",
    space_placeholder: "My new space",
    empty_spaces: "You don't have any empty workspaces",
    installing: "Installing...",
    install_success: "Team installed successfully!",
    install_error: "Failed to install team",
    connect_github: "Connect GitHub Account",
    connected: "Connected",
    load_more: "Load more",
    oauth_success: "GitHub connected successfully!",
    oauth_error: "Failed to connect GitHub",
    sign_in_required: "Sign in required",
    sign_in: "Sign in to continue",
    sort_by: "Sort by",
    newest: "Newest",
    popular: "Most popular",
    top_rated: "Top rated",
    write_review: "Write a review",
    your_rating: "Your rating",
    your_comment: "Your comment",
    submit_review: "Submit review",
    login_with_google: "Sign in with Google",
    signing_in: "Signing in...",
    not_found: "Team not found",
    oauth_callback_title: "Connecting GitHub...",
    oauth_callback_desc: "Please wait while we set up your connection.",
    oauth_success_title: "GitHub Connected!",
    oauth_success_desc: "You can now close this window and return to the app.",
    oauth_error_title: "Connection Failed",
    oauth_error_desc: "Please try again.",
    developer: "Developer",
    my_teams: "My Teams",
    publish: "Publish",
    unpublish: "Unpublish",
  },
  es: {
    title: "Marketplace de Equipos Agenticos",
    subtitle: "Encuentra el equipo perfecto para potenciar tu espacio de trabajo",
    search_placeholder: "Buscar equipos, categorías, palabras clave...",
    categories: "Categorías",
    all: "Todos",
    price: "Precio",
    free: "Gratis",
    paid: "De pago",
    rating: "Valoración",
    installs: "Instalaciones",
    reviews: "Reseñas",
    review_count: "{n} reseñas",
    install_count: "{n} instalaciones",
    install: "Instalar",
    installed: "Instalado",
    details: "Detalles",
    description: "Descripción",
    version: "Versión",
    tags: "Etiquetas",
    author: "Autor",
    updated: "Actualizado",
    latest_version: "Última Versión",
    screenshots: "Capturas",
    no_results: "No se encontraron equipos",
    loading: "Cargando...",
    error: "Algo salió mal",
    back: "Volver al Marketplace",
    your_teams: "Mis Equipos Agenticos",
    backoffice: "Backoffice",
    publish_team: "Publicar Equipo",
    edit_team: "Editar Equipo",
    team_name: "Nombre del Equipo",
    team_slug: "Slug de URL",
    team_description: "Descripción",
    team_short_desc: "Descripción Corta",
    team_category: "Categoría",
    team_tags: "Etiquetas (separadas por comas)",
    team_price: "Precio (€, 0 para gratis)",
    team_repo: "URL del Repositorio GitHub",
    team_tag: "Tag de Versión",
    team_screenshots: "URLs de capturas (una por línea)",
    save: "Guardar",
    cancel: "Cancelar",
    delete: "Eliminar",
    status_draft: "Borrador",
    status_published: "Publicado",
    no_teams: "Aún no has publicado ningún equipo",
    select_space: "Selecciona un espacio de trabajo",
    create_space: "Crear nuevo espacio",
    space_name: "Nombre del espacio",
    space_placeholder: "Mi nuevo espacio",
    empty_spaces: "No tienes espacios vacíos",
    installing: "Instalando...",
    install_success: "¡Equipo instalado con éxito!",
    install_error: "Error al instalar el equipo",
    connect_github: "Conectar Cuenta GitHub",
    connected: "Conectado",
    load_more: "Cargar más",
    oauth_success: "¡GitHub conectado con éxito!",
    oauth_error: "Error al conectar GitHub",
    sign_in_required: "Inicia sesión",
    sign_in: "Inicia sesión para continuar",
    sort_by: "Ordenar por",
    newest: "Más recientes",
    popular: "Más populares",
    top_rated: "Mejor valorados",
    write_review: "Escribir reseña",
    your_rating: "Tu valoración",
    your_comment: "Tu comentario",
    submit_review: "Enviar reseña",
    login_with_google: "Iniciar sesión con Google",
    signing_in: "Iniciando sesión...",
    not_found: "Equipo no encontrado",
    oauth_callback_title: "Conectando GitHub...",
    oauth_callback_desc: "Por favor espera mientras configuramos tu conexión.",
    oauth_success_title: "¡GitHub Conectado!",
    oauth_success_desc: "Ya puedes cerrar esta ventana y volver a la app.",
    oauth_error_title: "Conexión Fallida",
    oauth_error_desc: "Por favor, inténtalo de nuevo.",
    developer: "Desarrollador",
    my_teams: "Mis Equipos",
    publish: "Publicar",
    unpublish: "Despublicar",
  },
  pt: {
    title: "Marketplace de Equipes Agenticas",
    subtitle: "Encontre a equipa perfeita para impulsionar seu espaço de trabalho",
    search_placeholder: "Buscar equipas, categorias, palavras-chave...",
    categories: "Categorias",
    all: "Todas",
    price: "Preço",
    free: "Grátis",
    paid: "Pago",
    rating: "Avaliação",
    installs: "Instalações",
    reviews: "Avaliações",
    review_count: "{n} avaliações",
    install_count: "{n} instalações",
    install: "Instalar",
    installed: "Instalado",
    details: "Detalhes",
    description: "Descrição",
    version: "Versão",
    tags: "Tags",
    author: "Autor",
    updated: "Atualizado",
    latest_version: "Última Versão",
    screenshots: "Capturas",
    no_results: "Nenhuma equipa encontrada",
    loading: "Carregando...",
    error: "Algo deu errado",
    back: "Voltar ao Marketplace",
    your_teams: "Minhas Equipas Agenticas",
    backoffice: "Backoffice",
    publish_team: "Publicar Equipa",
    edit_team: "Editar Equipa",
    team_name: "Nome da Equipa",
    team_slug: "Slug de URL",
    team_description: "Descrição",
    team_short_desc: "Descrição Curta",
    team_category: "Categoria",
    team_tags: "Tags (separadas por vírgulas)",
    team_price: "Preço (€, 0 para grátis)",
    team_repo: "URL do Repositório GitHub",
    team_tag: "Tag de Versão",
    team_screenshots: "URLs de capturas (uma por linha)",
    save: "Salvar",
    cancel: "Cancelar",
    delete: "Excluir",
    status_draft: "Rascunho",
    status_published: "Publicado",
    no_teams: "Você ainda não publicou nenhuma equipa",
    select_space: "Selecione um espaço de trabalho",
    create_space: "Criar novo espaço",
    space_name: "Nome do espaço",
    space_placeholder: "Meu novo espaço",
    empty_spaces: "Você não tem espaços vazios",
    installing: "Instalando...",
    install_success: "Equipa instalada com sucesso!",
    install_error: "Falha ao instalar equipa",
    connect_github: "Conectar Conta GitHub",
    connected: "Conectado",
    load_more: "Carregar mais",
    oauth_success: "GitHub conectado com sucesso!",
    oauth_error: "Falha ao conectar GitHub",
    sign_in_required: "Faça login",
    sign_in: "Faça login para continuar",
    sort_by: "Ordenar por",
    newest: "Mais recentes",
    popular: "Mais populares",
    top_rated: "Melhor avaliados",
    write_review: "Escrever avaliação",
    your_rating: "Sua avaliação",
    your_comment: "Seu comentário",
    submit_review: "Enviar avaliação",
    login_with_google: "Entrar com Google",
    signing_in: "Entrando...",
    not_found: "Equipa não encontrada",
    oauth_callback_title: "Conectando GitHub...",
    oauth_callback_desc: "Aguarde enquanto configuramos sua conexão.",
    oauth_success_title: "GitHub Conectado!",
    oauth_success_desc: "Você pode fechar esta janela e voltar ao app.",
    oauth_error_title: "Conexão Falhou",
    oauth_error_desc: "Por favor, tente novamente.",
    developer: "Desenvolvedor",
    my_teams: "Minhas Equipas",
    publish: "Publicar",
    unpublish: "Despublicar",
  },
  fr: {
    title: "Marketplace d'Équipes Agentiques",
    subtitle: "Trouvez l'équipe parfaite pour booster votre espace de travail",
    search_placeholder: "Rechercher équipes, catégories, mots-clés...",
    categories: "Catégories",
    all: "Toutes",
    price: "Prix",
    free: "Gratuit",
    paid: "Payant",
    rating: "Note",
    installs: "Installations",
    reviews: "Avis",
    install: "Installer",
    installed: "Installé",
    description: "Description",
    version: "Version",
    tags: "Tags",
    author: "Auteur",
    loading: "Chargement...",
    error: "Une erreur est survenue",
    install_success: "Équipe installée avec succès !",
    install_error: "Échec de l'installation",
    sign_in: "Connectez-vous pour continuer",
    login_with_google: "Se connecter avec Google",
    not_found: "Équipe non trouvée",
  },
  de: {
    title: "Marktplatz für Agententeams",
    subtitle: "Finden Sie das perfekte Team für Ihren Arbeitsbereich",
    search_placeholder: "Teams, Kategorien, Schlüsselwörter suchen...",
    categories: "Kategorien",
    all: "Alle",
    price: "Preis",
    free: "Kostenlos",
    paid: "Bezahlt",
    rating: "Bewertung",
    installs: "Installationen",
    reviews: "Bewertungen",
    install: "Installieren",
    installed: "Installiert",
    description: "Beschreibung",
    version: "Version",
    tags: "Tags",
    author: "Autor",
    loading: "Laden...",
    error: "Etwas ist schief gelaufen",
    install_success: "Team erfolgreich installiert!",
    install_error: "Installation fehlgeschlagen",
    sign_in: "Melden Sie sich an, um fortzufahren",
    login_with_google: "Mit Google anmelden",
    not_found: "Team nicht gefunden",
  },
  ca: {
    title: "Marketplace d'Equips Agentics",
    subtitle: "Troba l'equip perfecte per potenciar el teu espai de treball",
    search_placeholder: "Cercar equips, categories, paraules clau...",
    categories: "Categories",
    all: "Totes",
    price: "Preu",
    free: "Gratis",
    paid: "De pagament",
    rating: "Valoració",
    installs: "Instal·lacions",
    reviews: "Ressenyes",
    install: "Instal·lar",
    installed: "Instal·lat",
    description: "Descripció",
    version: "Versió",
    tags: "Etiquetes",
    author: "Autor",
    loading: "Carregant...",
    error: "Alguna cosa ha anat malament",
    install_success: "Equip instal·lat amb èxit!",
    install_error: "Error en instal·lar l'equip",
    sign_in: "Inicia sessió per continuar",
    login_with_google: "Iniciar sessió amb Google",
    not_found: "Equip no trobat",
  },
};

function getTranslatedValue(obj, lang, key, fallback) {
  const langObj = obj[lang];
  if (langObj && langObj[key] !== undefined) return langObj[key];
  if (obj.en && obj.en[key] !== undefined) return obj.en[key];
  return fallback || key;
}

const I18nContext = createContext();

export function I18nProvider({ children }) {
  const [lang, setLangState] = useState(() => {
    try { return localStorage.getItem("makeyourcrew-lang") || "en"; }
    catch { return "en"; }
  });

  useEffect(() => {
    try { localStorage.setItem("makeyourcrew-lang", lang); } catch {}
  }, [lang]);

  const setLang = useCallback((code) => setLangState(code), []);

  const t = useCallback((key, replacements = {}) => {
    let val = getTranslatedValue(TRANSLATIONS, lang, key, key);
    if (typeof val === "string") {
      for (const [k, v] of Object.entries(replacements)) {
        val = val.replace(`{${k}}`, v);
      }
    }
    return val;
  }, [lang]);

  return (
    <I18nContext.Provider value={{ lang, setLang, t, LANGUAGES }}>
      {children}
    </I18nContext.Provider>
  );
}

export function useI18n() {
  const ctx = useContext(I18nContext);
  if (!ctx) throw new Error("useI18n must be used within I18nProvider");
  return ctx;
}
